import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Snackbar, Alert, CircularProgress, Dialog, DialogActions, DialogTitle  } from '@mui/material';
import axios from 'axios'
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import ItemPrintPDF from "../../../utils/ItemPrintPDF.js";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import NewWinPDF from '../../../components/NewWinPDF.js';
import { MdOutlineRefresh } from "react-icons/md";

let date = new Date();
let year = date.getFullYear();
let month = date.getMonth();
month += 1;
if (month <= 9){
    month = "0" + month;
}
let day = date.getDate();
if (day <= 9){
    day = "0" + day;
}
let today = year + '-' + month + '-' + day;

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  oitemListPrintConfigBlockH1:{
    padding:'40px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  formDiv:{
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column'
    },
  },
  secondFormDiv:{
    padding:'0 20px',

    [theme.breakpoints.down(1025)]: {
      padding:'20px 0',
    },
  },
  timeH1:{
    paddingTop:'30px',

    [theme.breakpoints.down(1025)]: {
      textAlign:'center'
    },
  },

}));

const ItemListPrintConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const [dayDate, setDayDate] = useState(today)
  const [endDayDate, setEndDayDate] = useState(today)
  const [odState, setOdState] = useState('주문')
  const [picId, setPicId] = useState(1) 

  const [picList, setPicList] = useState([]) 

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [data, setData] = useState([]);
  const [exData, setExData] = useState()
  const [exData2, setExData2] = useState()

  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState('');
  const [picName, setPicName] = useState('') 

  const [preview, setPreview] = useState(false)

  useEffect(() => {
    setData([])
    setExData()
    setExData2()
    setPreview(false)
  }, [dayDate, endDayDate, odState, picId])

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setData([])
      setPicList([])
      setPicId(1)
      setDayDate(today)
      setEndDayDate(today)
    }
  }, [])

  const getItems = async() => {
    try {
      const res = await axios.post('/api/adm/memberGetPic/' )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
      
      setPicList(res.data.picList)

    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()
  } , [])


  const getPrintItem = async() => {
    setLoading(true)
    try {
      const res = await axios.post('/api/adm/printOrder2/', {od_time: dayDate, end_time: endDayDate, od_state: odState, pic_id: picId} )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
      if(Object.values(res.data.result).length === 0) {
        setLoading(false)
        return setDialog('데이터가 없습니다.')
      }

      const resultData = Object.values(res.data.result)

      let dataArr = []

      const srotedArr = Object.values(res.data.result).reduce((res, itm) => [...res, itm[0]['it_name']], []).sort()

      srotedArr.forEach(itm => {
        resultData.forEach(item => {
          if(item[0]['it_name'] === itm) {
            dataArr.push(item)
          }
        })
      })


      setData(dataArr)

      let dataArr2 = []

      dataArr.forEach((itm) => {
        let arr = [...itm]
        arr.push({it_name: '합계', od_num: '', sum_num: arr[0]['sum_qty'], sum_qty: arr[0]['sum_qty']})
        dataArr2.push(arr)
      })
      
      let exex2 = dataArr2.reduce((res, itm) => [...res, ...itm], [])
      
      let exexex = exex2.reduce((result, item) => [
        ...result, 
        [item['it_name'], '', item['od_num'], item['sum_num']]
      ], [
        ['시작일', dayDate, '종료일', endDayDate, '담당자', picList.filter((it) => it['pic_id'] === picId)[0]['pic_name']],
        ['상품명', '체크', '주문번호', '수량' ],
      ])

      let exexexex = XLSX.utils.aoa_to_sheet(exexex)

      setExData2(exexexex)

      let ws = XLSX.utils.json_to_sheet(res.data.excel)
      ws['!cols'] = [
        {wch:10},
        {wch:30},
        {wch:10}
      ]

      setExData(ws)

    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
    setLoading(false)
  }


  useEffect(() => {
    if (picList.length > 0) {
      setPicName(picList.filter((item) => item['pic_id'] === picId)[0]['pic_name'])
    }
    setData([])
  } , [picId])
  
  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  const fileDownload = () => {
    const wb = { Sheets: { data: exData }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const datae = new Blob([excelBuffer], { type: fileType });
    saveAs(datae, `품목${dayDate}~${endDayDate}${odState}${picName}${fileExtension}`);
  };

  const fileDownload2 = () => {
    const wb = { Sheets: { data: exData2 }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const datae = new Blob([excelBuffer], { type: fileType });
    saveAs(datae, `2품목${dayDate}~${endDayDate}${odState}${picName}${fileExtension}`);
  };

  return (
    <div className={classes.itemListPrintConfigBlock}>
      <div className={classes.box}>
        <h1 className={classes.oitemListPrintConfigBlockH1}>
          품목내역출력
          <div
              onClick={() => {
                setData([])
                setPicId(1)
                setOdState('주문')
                setDayDate(today)
                setEndDayDate(today)
              }}
            style={{cursor:'pointer'}}
          >
            <MdOutlineRefresh/>
          </div>
        </h1>
        <div className={classes.formDiv}>
          <div className={classes.firstFormDiv}>
            <h3 style={{marginBottom: 5}}>시작일</h3>
            <TextField
              type="date"
              value={dayDate}
              style={{ width:'250px' }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setDayDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.firstFormDiv}>
            <h3 style={{marginBottom: 5}}>종료일</h3>
            <TextField
              type="date"
              value={endDayDate}
              style={{ width:'250px' }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setEndDayDate(e.target.value)
              }}
            />
          </div>
          <div className={classes.secondFormDiv}>
            <h3 style={{marginBottom: 5}}>상태</h3>
            <FormControl 
              //size="small"
            >
              <Select
                value={odState}
                onChange={(e) => setOdState(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value='주문'>주문</MenuItem>
                <MenuItem value='취소'>취소</MenuItem>
                <MenuItem value='완료'>완료</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className={classes.secondFormDiv}>
            <h3 style={{marginBottom: 5}}>담당자</h3>
            <FormControl>
              <Select
                style={{ width:'250px' }}
                value={picId}
                onChange={(e) => setPicId(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                {picList.length > 0 &&
                      picList.map((item) => (
                      <MenuItem key={item['pic_id']} value={item['pic_id']}>{item['pic_name']}</MenuItem>
                      ))
                }
              </Select>
            </FormControl>
          </div>
    
          <div className={classes.thirdFormDiv}>
            {loading ? 
              <CircularProgress /> : 
              (<Button 
                variant="outlined"
                onClick={() => {
                  const today1 = new Date(today);
                  const day1 = new Date(dayDate);
                  const day2 = new Date(endDayDate);
        
                  if(day1 > today1) return setDialog('현재일보다 선택일이 더 큽니다!')
                  if(day1 > day2) return setDialog('시작일이 종료일보다 더 큽니다!')
                  getPrintItem()
                }}    
              >
                확인
              </Button>)
            }
          </div>
        </div>
  
        <div
          style={{width: '100%', display : 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
        >
          <h1 className={classes.timeH1}>
            다소 시간이 소요 됩니다. (로딩중일때는 다른작업 하지 마십시오.)
          </h1>
          {data.length > 0 && (
              <PDFDownloadLink 
                document={<ItemPrintPDF data={data} picList={picList} picId={picId} dayDate={dayDate} endDayDate={endDayDate}/>} 
                fileName={`품목${dayDate}~${endDayDate}${odState}${picName}`}
              >
                {({loadingPdf}) => (loadingPdf ? 
                  <button>로딩중</button> :
                  <button
                    style={{
                      width: 500,
                      background:'#007235',
                      borderRadius:'0',
                      color: 'white'
                    }}
                  >
                    {`품목${dayDate}~${endDayDate}${odState}${picName}`} PDF다운로드
                  </button>
                 )}
              </PDFDownloadLink>
        )}

        {exData && (
          <button 
            onClick={fileDownload}
            style={{
              width: 500,
              background:'#007235',
              borderRadius:'0',
              color: 'white'
            }}
          >
            {`품목${dayDate}~${endDayDate}${odState}${picName}`} 엑셀다운로드
          </button>
        )}

        {exData2 && (
          <button 
            onClick={fileDownload2}
            style={{
              width: 500,
              background:'#007235',
              borderRadius:'0',
              color: 'white',
              marginTop: 5
            }}
          >
            {`품목${dayDate}~${endDayDate}${odState}${picName}`} 엑셀다운로드2
          </button>
        )}

        {data.length > 0 && (
          <button
            onClick={() => setPreview(!preview)}
            style={{
              width: 500,
              background:'#007235',
              borderRadius:'0',
              color: 'white',
              marginTop: 5
            }}
          >
            미리보기
          </button>
        )}

        {preview && (
          <NewWinPDF>
              <PDFViewer
                style={{width: '100%', height: '100%'}}
              >
                <ItemPrintPDF data={data} picList={picList} picId={picId} dayDate={dayDate} endDayDate={endDayDate}/>
              </PDFViewer>
          </NewWinPDF>
        )} 

        </div>


      </div>
      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
      <Dialog
        open={dialog === '' ? false : true}
        onClose={() => setDialog('')}
      >
        <DialogTitle id="alert-dialog-title">
          {dialog}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setDialog('')} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ItemListPrintConfig
